import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { AlertTitle, BadgesTable, BootstrapTable, CheckboxTitle, InputsTable, ProgressbarTitle, RadioButtonsTitle, SelectTable, SwitchTable, TableComponent, TooltipTriggersTitle, UIComponentsTitle } from "../../../Constant";
import { CommonTableComponent } from "./Common/CommonTableComponent";
import { ALRT_TABLE_DATA, BADGE_TABLE_DATA, CHECK_BOX_DATA, INPUT_TABLE_DATA, PROGRESS_TABLE_DATA, RADIO_BOX_DATA, SELECT_BOX_DATA, SWITCH_TABLE_DATA, TOOLTIP_TABLE_DATA, UI_COMPONANT_DATA } from "../../../Data/BootstrapTable/TableComponant";

const TableComponentsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={TableComponent} parent={BootstrapTable} title={TableComponent} />
      <Container fluid>
        <Row>
          <CommonTableComponent title={UIComponentsTitle} data={UI_COMPONANT_DATA} />
          <CommonTableComponent title={AlertTitle} data={ALRT_TABLE_DATA}/>
          <CommonTableComponent title={ProgressbarTitle} data={PROGRESS_TABLE_DATA} tableClass='checkbox-td-width'/>
          <CommonTableComponent title={CheckboxTitle} data={CHECK_BOX_DATA} tableClass='checkbox-td-width'/>
          <CommonTableComponent title={RadioButtonsTitle} data={RADIO_BOX_DATA} tableClass='radio-first-col-width'/>
          <CommonTableComponent title={SelectTable} data={SELECT_BOX_DATA} tableClass='checkbox-td-width'/>
          <CommonTableComponent title={InputsTable} data={INPUT_TABLE_DATA} tableClass='checkbox-td-width'/>
          <CommonTableComponent title={BadgesTable} data={BADGE_TABLE_DATA}/>
          <CommonTableComponent title={TooltipTriggersTitle} data={TOOLTIP_TABLE_DATA}/>
          <CommonTableComponent title={SwitchTable} data={SWITCH_TABLE_DATA}/>
        </Row>
      </Container>
    </>
  );
};

export default TableComponentsContainer;
